import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  Divider,
  CircularProgress,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import ExpenseReportItems from "./expense-report/ExpensesItems";
import ExpenseReportCommunication from "./expense-report/communication";
import ExpenseReportRelatedRecords from "./expense-report/relatedRecords";
import ExpenseReportSystemInformation from "./expense-report/systemInformation";
import ExpenseReportCustom from "./expense-report/custom";
import ExpenseReportApproveList from "./expense-report/approveList";
import ExpenseReportEft from "./expense-report/eft";
import ExpenseReportApprovalHistory from "./expense-report/ApprovalHistory";
import { getTransactionExpenseReportDetail } from "../../api/expense-report";
import { GridComp4,GridComp6 } from "../../components/GridComponents";
import { CustomCheckBox } from "../../components/CheckboxComp";
const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function TransactionTypeExpenseReport() {
  const classes = useStyles();
  const params = useParams();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
const [loading, setLoading] = useState(false);
  /*----------------End Tabs-----------------*/
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (user.token) {
      getTransactionExpenseReportDetailData();
    }
  }, []);
  async function getTransactionExpenseReportDetailData() {
    setLoading(true);
    try {
      const { data } = await getTransactionExpenseReportDetail(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
     <>
       <Typography component="h2" fontWeight={500} className="pageTitle">
       Expense Report
       </Typography>
 
       {/*Primary Information*/}
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
             Primary Information
           </Typography>
           <Link to={"/transaction-type/" + params.slug}>
             <Button size="small" variant="contained" className="backBtn">
               Go Back
             </Button>
           </Link>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
     
 
       {/*Classification*/}
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
           Classification
           </Typography>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
           Approval Information
           </Typography>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
     </>
   ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Expense Report
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        <span className="para-no"><strong>{rowData?.tranid}</strong> {rowData?.employee}</span>{" "}
       
        <Button className="blue-button" size="small" sx={{ ml: 1 }}>
        {rowData?.exp_report_status}
        </Button>
      </Typography>
      {/*Primary Information*/}

     
        {/* {rowData?.map((el, index) => ( */}
          <Box className="viewBox" >
            <Box
              className="headerItems"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              pb={2}
            >
              <Typography
                component="h5"
                fontWeight={500}
                className="pageHeading1"
              >
                Primary Information
              </Typography>
              <Link to={"/transaction-type/" + params.slug}>
                <Button size="small" className="backBtn">
                  Go Back
                </Button>
              </Link>
            </Box>
            <Box className="viewDetilsBox">
              <>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={6} md={8}>
                    <Grid container className="mb-2">
                      <GridComp6
                        title={"EXP. REPT. #"}
                        data={rowData?.exp_rept_num}
                      />
                      <GridComp6 title={"DATE"} data={rowData?.date} />

                      <GridComp6 title={"EMPLOYEE"} data={rowData?.employee} />
                      <GridComp6
                        title={"POSTING PERIOD"}
                        data={rowData?.posting_period}
                      />
                      <GridComp6 title={"PC/PROJECT"} data={rowData?.pcproject} />
                      <GridComp6 title={"ORIGINAL EXP REPORT "} data={rowData?.org_exp_report} />
                      <GridComp6
                        title={"EXPENSE REPORT NAME"}
                        data={rowData?.expense_report_name}
                      />
                      <GridComp6
                        title={"EXPENSE REPORT STATUS"}
                        data={rowData?.exp_report_status}
                      />
                      <GridComp6 />
                      <GridComp6 title={"NEXT APPROVER"} data={rowData?.next_approver} />
                      <GridComp6 />
                      <GridComp6 title={"ACCOUNT FOR CORPORATE CARD EXPENSES"} data={rowData?.acc} />
                      <GridComp6 />
                      <GridComp6 title={"CURRENCY"} data={rowData?.currency} />
                    </Grid>
                  </Grid>
                  {/* -----------Summary Box------------- */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Box className="viewBox">
                      <Box
                        className="headerItemsSB"
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        pb={2}
                      >
                        <Typography
                          component="h5"
                          fontWeight={500}
                          className="pageHeading1"
                        >
                          Summary
                        </Typography>
                      </Box>
                      <Box className="viewDetilsBox1">
                        <Grid container>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">EXPENSES TOTAL</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{rowData?.expenses_total}</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">TOTAL IN BASE CURRENCY</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">
                              {rowData?.total_in_base_summary}
                            </p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">
                              NON-REIMBURSABLE EXPENSES (TAX EXCL.)
                            </p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">
                              {rowData?.non_reimbursable_expenses}
                            </p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">REIMBURSABLE EXPENSES</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">
                              {rowData?.reimbursable_expenses}
                            </p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">CORPORATE CARD</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{rowData?.corporate_card}</p>
                          </Grid>
                        </Grid>
                        <Divider />
                        <Grid container sx={{ mt: 1 }}>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">ADVANCE TO APPLY</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{rowData?.advance_to_apply}</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">
                              TOTAL REIMBURSABLE AMOUNT
                            </p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">
                              {rowData?.total_in_base_summary}
                            </p>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </>
            </Box>
          </Box>
        {/*  ))} */}
      

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((el, i) => ( */}
            <Grid container className="mb-2" >
              <GridComp4 title={"SUBSIDIARY"} data={rowData?.subsidiary} />
              <GridComp4 title={"DEPARTMENT"} data={rowData?.department} />
              <GridComp4 title={"SERVICE LINE"} data={rowData?.service_line} />
             
            </Grid>
          {/* ))} */}
        </Box>
      </Box>
      {/*Advanced Approval */}
      {/* <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Advanced Approval
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <>
            {rowData?.map((el, i) => (
              <Grid container className="mb-2" key={i}>
                <GridComp4 title={"REQESTOR"} data={rowData?.reject_reason} />
                <CustomCheckBox title={"IS DELEGATED"} data={rowData?.is_delegated} />
                <GridComp4
                  title={"APPROVAL STATUS"}
                  data={rowData?.approval_status}
                />
                <GridComp4
                  title={"REJECTION REASON"}
                  data={rowData?.rejection_reason}
                />
                <GridComp4 title={"NEXT APPROVER/S"} data={rowData?.next_approvers} />
                <GridComp4
                  title={"NEXT ROLE APPROVER"}
                  data={rowData?.next_role_approver}
                />
              </Grid>
            ))}
          </>
        </Box>
      </Box> */}
      {/*Approval Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Approval Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <>
            {/* {rowData?.map((el, i) => ( */}
              <Grid container className="mb-2" >
                <GridComp4 title={"ACCOUNTING APPROVED BY USER"} data={rowData?.accounting_approved_by_user} />
                <GridComp4 title={"EXPENSE REJECTION REASON"} data={rowData?.expense_rejection_reason} />
                <GridComp4 title={"EXPENSE REPORT REJECTED BY"} data={rowData?.expense_report_rejected_by} />
                <GridComp4 title={"ACCOUNTING APPROVAL DATE/TIME"} data={rowData?.accounting_approval_datetime} />            
                <GridComp4 title={"REJECTION DETAILS"} data={rowData?.pst} />
                <GridComp4 title={"REJECTED/VOIDED DATE/TIME"} data={rowData?.rejected_voided_datetime} />           
                <GridComp4 title={"EXEC APPROVAL USER EXEC APPROVAL DATE"} data={rowData?.exec_approval_user_exec_approval_date} />                   
                
              </Grid>
            {/* ))} */}
          </>
        </Box>
      </Box>
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            //className={`${classes.spacedTabs} tabs-bkg`}
            className="tabs-bkg tabs-spacing"
            // className="tabs-bkg"
          >
            <Tab label="Expenses" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
          </Tabs>
          {/*------------Expense Items------------*/}
          <TabPanel value={tabIndex} index={0}>
            <ExpenseReportItems />
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={1}>
            {tabIndex === 1 && <ExpenseReportCommunication />}
          </TabPanel>
          {/*------------Related Record------------*/}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && <ExpenseReportRelatedRecords />}
          </TabPanel>
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && <ExpenseReportSystemInformation />}
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && <ExpenseReportCustom />}
          </TabPanel>
          
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <ExpenseReportEft />}
          </TabPanel>
         
        </Box>
      </Box>
    </>
  );
}
